import React, { useEffect, useState } from 'react'
import { getLocalPath, isLocal, isProduction } from '../../../utility'
import { fetchData } from '../../../data'
import './blogCta.css'
import { HippostdHtml } from '../blogArticle/componentTypes/HippostdHtml.jsx'
import { isInstitutional } from '../../../../global/authentication/authentication-manager.js'

const BlogCta = ({ component }) => {
  const [document, setDocument] = useState(null)
  const [subscription, setSubscription] = useState(null)

  let prefix = ''

  if (isInstitutional()) {
    prefix = '/content/documents/cti-institutional/'
  } else {
    prefix = '/content/documents/cti-blog-spa/'
  }

  useEffect(() => {
    const params = component?.model?.meta?.params
    const subscription = params?.subscription || 'Latest Insights'
    setSubscription(subscription)
    if (params?.document) {
      const itemsUrl = `${getLocalPath()}/halapi/documents?_scope=${prefix}${
        params.document
      }`

      fetchData(itemsUrl)
        .then((data) => {
          if (!data) {
            throw new Error(
              `HalApi eror fetching url: ${itemsUrl}, data not defined`
            )
          }
          const docData = data?._embedded.documents[0]
          const path = docData?.image?._meta?.mirror?.path
          const imagPathPrefix = isLocal()
            ? '/cti-site/binaries/'
            : '/binaries/'
          setDocument({
            content: docData?.html?.content,
            imagePath: path ? `${imagPathPrefix}${path}` : undefined,
          })
        })
        .catch((error) => {
          if (!isProduction()) {
            console.log(error)
          }
        })
    }
  }, [])

  return (
    document && (
      <BlogCtaRendering
        content={document?.content}
        subscription={subscription}
        imagePath={document?.imagePath}
      />
    )
  )
}

export const BlogCtaRendering = ({ content, imagePath, subscription }) => {
  return (
    <div data-interaction-studio="IS010-2" className="interaction-studio">
      <div className="blog-cta-240 u-flex u-flexAlignItemsCenter u-flexJustifyCenter u-posRelative u-bgColorBrand">
        {imagePath && (
          <div
            className="blog-cta-bg u-posAbsolute  u-sizeFull"
            style={{
              backgroundImage: `url(${imagePath})`,
            }}
            role="img"
            aria-label="banner"
          ></div>
        )}
        <div className="outerContainer">
          <div className="u-flex u-flexCol u-flexAlignItemsCenter u-sizeConstrained">
            <div className="Content u-textColorWhite u-textBold u-textSizeMsrp1">
              <HippostdHtml value={content || ''} />
            </div>
            <div className="u-flex u-flexAlignItemsCenter">
              <email-subscription-modal
                data-use-unlabeled-button="true"
                data-subscription-name={subscription}
                raspberry
              ></email-subscription-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { BlogCta }
